// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shorts_shortsContainer__TuPdw {
  background-color:#1a1a1a;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.Shorts_title__RJpts {
  color: white;
  font-size: 20px;
  padding-bottom: 0.5rem;
  font-weight: 700;
  max-width: 95%;
  margin: 0 auto;
  padding-top: 0.5rem;

}

.Shorts_shortsWrapper__1S07H {
  position: relative;
  max-width: 95%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  height: 380px;
}

.Shorts_swiper__V5exP {
  width: 100%;
  max-width: 95%;
  position: relative;
  padding: 0 10px;
}

.Shorts_shortCardWrapper__SK-vG {
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.Shorts_shortCardWrapper__SK-vG:hover {
  transform: scale(1.02);
}

.Shorts_shortCard__2Cs3H {
  overflow: hidden;
  position: relative;
  aspect-ratio: 9/16;
  height: 100%;
}

.Shorts_thumbnailContainer__JnQUX {
  position: relative;
  width: 100%;
  height: 85%;
}

.Shorts_thumbnail__xf5Qh {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.Shorts_playButton__WdHTW {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.Shorts_playIcon__uCjOS {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 16px;
  border-color: transparent transparent transparent #000;
  margin-left: 3px;
}

.Shorts_navButton__zJhSu {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background-color: rgba(255, 0, 0, 0.8);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background-color 0.3s ease, opacity 0.3s ease;
}

.Shorts_navButton__zJhSu:hover {
  background-color: rgb(255, 0, 0);
}

.Shorts_navButton__zJhSu:focus {
  outline: 2px solid white;
  outline-offset: 2px;
}

.Shorts_prevButton__0uYyE {
  left: 0;
}

.Shorts_nextButton__E2vLF {
  right: 0;
}

/* Loading indicator */
.Shorts_loadingSlide__0uki3 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
}

.Shorts_loadingIndicator__Iycb9 {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: Shorts_spin__EGPxq 1s ease-in-out infinite;
}

@keyframes Shorts_spin__EGPxq {
  to {
    transform: rotate(360deg);
  }
}

/* Player styles */
.Shorts_playerWrapper__t\\+NoM {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: black;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.Shorts_closePlayerButton__z3a4p {
  position: absolute;
  top: 6rem;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  transition: background-color 0.3s ease;
}

.Shorts_closePlayerButton__z3a4p:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.Shorts_closePlayerButton__z3a4p:focus {
  outline: 2px solid white;
  outline-offset: 2px;
}

/* Responsive styles */
/* Extra large screens */
@media screen and (min-width: 1900px) {
  .Shorts_shortsWrapper__1S07H {
    max-width: 1800px;
  }
  
  .Shorts_swiper__V5exP {
    max-width: 1600px;
  }
  
  .Shorts_title__RJpts {
    font-size: 2rem;
  }
  
  .Shorts_navButton__zJhSu {
    width: 50px;
    height: 50px;
    font-size: 2rem;
  }
}

/* Large screens */
@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .Shorts_shortsWrapper__1S07H {
    max-width: 1500px;
  }
  
  .Shorts_swiper__V5exP {
    max-width: 1400px;
  }
  
  .Shorts_title__RJpts {
    font-size: 1.8rem;
  }
}

/* Medium-large screens */
@media screen and (min-width: 1300px) and (max-width: 1599px) {
  .Shorts_shortsWrapper__1S07H {
    max-width: 95%;
  }
  
  .Shorts_swiper__V5exP {
    max-width: 95%;
  }
  
  .Shorts_title__RJpts {
    font-size: 20px;
  }
}

/* Medium screens */
@media screen and (min-width: 1024px) and (max-width: 1299px) {
  .Shorts_shortsWrapper__1S07H {
    max-width: 95%;
  }
  
  .Shorts_swiper__V5exP {
    max-width: 95%;
  }
}

/* Small-medium screens */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .Shorts_shortsContainer__TuPdw {
    padding: 1.5rem 0;
  }
  
  .Shorts_title__RJpts {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }
  
  .Shorts_shortsWrapper__1S07H {
    max-width: 700px;
  }
  
  .Shorts_swiper__V5exP {
    max-width: 650px;
  }
  
  .Shorts_navButton__zJhSu {
    width: 35px;
    height: 35px;
    font-size: 1.2rem;
  }
  
  .Shorts_playButton__WdHTW {
    width: 35px;
    height: 35px;
  }
  
  .Shorts_playIcon__uCjOS {
    border-width: 7px 0 7px 14px;
  }
  .Shorts_shortsWrapper__1S07H {
    height: 300px;
  }
  .Shorts_closePlayerButton__z3a4p {
    top: 6rem;
  }
}

/* Small screens */
@media screen and (min-width: 480px) and (max-width: 767px) {
  .Shorts_shortsContainer__TuPdw {
    padding: 1.2rem 0;
  }
  
  .Shorts_title__RJpts {
    font-size: 1.3rem;
    margin-bottom: 1rem;
  }
  
  .Shorts_shortsWrapper__1S07H {
    max-width: 100%;
    padding: 0 0.5rem;
  }
  
  .Shorts_navButton__zJhSu {
    width: 32px;
    height: 32px;
    font-size: 1.1rem;
    opacity: 0.8;
  }
  
  .Shorts_playButton__WdHTW {
    width: 32px;
    height: 32px;
  }
  
  .Shorts_playIcon__uCjOS {
    border-width: 6px 0 6px 12px;
  }
  
  .Shorts_closePlayerButton__z3a4p {
    width: 35px;
    height: 35px;
    font-size: 20px;
  }
}

/* Extra small screens */
@media screen and (max-width: 479px) {
  .Shorts_shortsContainer__TuPdw {
    padding: 1rem 0;
  }
  
  .Shorts_title__RJpts {
    font-size: 1.2rem;
    margin-bottom: 0.8rem;
  }
  
  .Shorts_shortsWrapper__1S07H {
    max-width: 100%;
    padding: 0px 20px 0px 0px;
    height: auto;
  }

  .Shorts_thumbnailContainer__JnQUX {
    height: 100%;
  }
  
  .Shorts_navButton__zJhSu {
    width: 28px;
    height: 28px;
    font-size: 1rem;
    opacity: 0.7;
  }
  
  .Shorts_playButton__WdHTW {
    width: 28px;
    height: 28px;
  }
  
  .Shorts_playIcon__uCjOS {
    border-width: 5px 0 5px 10px;
  }
  
  .Shorts_closePlayerButton__z3a4p {
    width: 30px;
    height: 30px;
    font-size: 18px;
    top: 6rem;
    right: 15px;
  }
  
  .Shorts_shortCard__2Cs3H {
    aspect-ratio: 9/16;
  }

}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/Shorts.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,qDAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;AAEF","sourcesContent":[".shortsContainer {\n  background-color:#1a1a1a;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.title {\n  color: white;\n  font-size: 20px;\n  padding-bottom: 0.5rem;\n  font-weight: 700;\n  max-width: 95%;\n  margin: 0 auto;\n  padding-top: 0.5rem;\n\n}\n\n.shortsWrapper {\n  position: relative;\n  max-width: 95%;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1rem;\n  height: 380px;\n}\n\n.swiper {\n  width: 100%;\n  max-width: 95%;\n  position: relative;\n  padding: 0 10px;\n}\n\n.shortCardWrapper {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.shortCardWrapper:hover {\n  transform: scale(1.02);\n}\n\n.shortCard {\n  overflow: hidden;\n  position: relative;\n  aspect-ratio: 9/16;\n  height: 100%;\n}\n\n.thumbnailContainer {\n  position: relative;\n  width: 100%;\n  height: 85%;\n}\n\n.thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.playIcon {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 0 8px 16px;\n  border-color: transparent transparent transparent #000;\n  margin-left: 3px;\n}\n\n.navButton {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 0, 0, 0.8);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  transition: background-color 0.3s ease, opacity 0.3s ease;\n}\n\n.navButton:hover {\n  background-color: rgb(255, 0, 0);\n}\n\n.navButton:focus {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}\n\n.prevButton {\n  left: 0;\n}\n\n.nextButton {\n  right: 0;\n}\n\n/* Loading indicator */\n.loadingSlide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 200px;\n}\n\n.loadingIndicator {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Player styles */\n.playerWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: black;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.closePlayerButton {\n  position: absolute;\n  top: 6rem;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n  transition: background-color 0.3s ease;\n}\n\n.closePlayerButton:hover {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.closePlayerButton:focus {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}\n\n/* Responsive styles */\n/* Extra large screens */\n@media screen and (min-width: 1900px) {\n  .shortsWrapper {\n    max-width: 1800px;\n  }\n  \n  .swiper {\n    max-width: 1600px;\n  }\n  \n  .title {\n    font-size: 2rem;\n  }\n  \n  .navButton {\n    width: 50px;\n    height: 50px;\n    font-size: 2rem;\n  }\n}\n\n/* Large screens */\n@media screen and (min-width: 1600px) and (max-width: 1899px) {\n  .shortsWrapper {\n    max-width: 1500px;\n  }\n  \n  .swiper {\n    max-width: 1400px;\n  }\n  \n  .title {\n    font-size: 1.8rem;\n  }\n}\n\n/* Medium-large screens */\n@media screen and (min-width: 1300px) and (max-width: 1599px) {\n  .shortsWrapper {\n    max-width: 95%;\n  }\n  \n  .swiper {\n    max-width: 95%;\n  }\n  \n  .title {\n    font-size: 20px;\n  }\n}\n\n/* Medium screens */\n@media screen and (min-width: 1024px) and (max-width: 1299px) {\n  .shortsWrapper {\n    max-width: 95%;\n  }\n  \n  .swiper {\n    max-width: 95%;\n  }\n}\n\n/* Small-medium screens */\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .shortsContainer {\n    padding: 1.5rem 0;\n  }\n  \n  .title {\n    font-size: 1.4rem;\n    margin-bottom: 1.2rem;\n  }\n  \n  .shortsWrapper {\n    max-width: 700px;\n  }\n  \n  .swiper {\n    max-width: 650px;\n  }\n  \n  .navButton {\n    width: 35px;\n    height: 35px;\n    font-size: 1.2rem;\n  }\n  \n  .playButton {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .playIcon {\n    border-width: 7px 0 7px 14px;\n  }\n  .shortsWrapper {\n    height: 300px;\n  }\n  .closePlayerButton {\n    top: 6rem;\n  }\n}\n\n/* Small screens */\n@media screen and (min-width: 480px) and (max-width: 767px) {\n  .shortsContainer {\n    padding: 1.2rem 0;\n  }\n  \n  .title {\n    font-size: 1.3rem;\n    margin-bottom: 1rem;\n  }\n  \n  .shortsWrapper {\n    max-width: 100%;\n    padding: 0 0.5rem;\n  }\n  \n  .navButton {\n    width: 32px;\n    height: 32px;\n    font-size: 1.1rem;\n    opacity: 0.8;\n  }\n  \n  .playButton {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .playIcon {\n    border-width: 6px 0 6px 12px;\n  }\n  \n  .closePlayerButton {\n    width: 35px;\n    height: 35px;\n    font-size: 20px;\n  }\n}\n\n/* Extra small screens */\n@media screen and (max-width: 479px) {\n  .shortsContainer {\n    padding: 1rem 0;\n  }\n  \n  .title {\n    font-size: 1.2rem;\n    margin-bottom: 0.8rem;\n  }\n  \n  .shortsWrapper {\n    max-width: 100%;\n    padding: 0px 20px 0px 0px;\n    height: auto;\n  }\n\n  .thumbnailContainer {\n    height: 100%;\n  }\n  \n  .navButton {\n    width: 28px;\n    height: 28px;\n    font-size: 1rem;\n    opacity: 0.7;\n  }\n  \n  .playButton {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .playIcon {\n    border-width: 5px 0 5px 10px;\n  }\n  \n  .closePlayerButton {\n    width: 30px;\n    height: 30px;\n    font-size: 18px;\n    top: 6rem;\n    right: 15px;\n  }\n  \n  .shortCard {\n    aspect-ratio: 9/16;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortsContainer": `Shorts_shortsContainer__TuPdw`,
	"title": `Shorts_title__RJpts`,
	"shortsWrapper": `Shorts_shortsWrapper__1S07H`,
	"swiper": `Shorts_swiper__V5exP`,
	"shortCardWrapper": `Shorts_shortCardWrapper__SK-vG`,
	"shortCard": `Shorts_shortCard__2Cs3H`,
	"thumbnailContainer": `Shorts_thumbnailContainer__JnQUX`,
	"thumbnail": `Shorts_thumbnail__xf5Qh`,
	"playButton": `Shorts_playButton__WdHTW`,
	"playIcon": `Shorts_playIcon__uCjOS`,
	"navButton": `Shorts_navButton__zJhSu`,
	"prevButton": `Shorts_prevButton__0uYyE`,
	"nextButton": `Shorts_nextButton__E2vLF`,
	"loadingSlide": `Shorts_loadingSlide__0uki3`,
	"loadingIndicator": `Shorts_loadingIndicator__Iycb9`,
	"spin": `Shorts_spin__EGPxq`,
	"playerWrapper": `Shorts_playerWrapper__t+NoM`,
	"closePlayerButton": `Shorts_closePlayerButton__z3a4p`
};
export default ___CSS_LOADER_EXPORT___;
